import React from 'react'
import Navigation from './Navigation'
import "./Home.css"
import "../App.css"
import TopD from './TopD';
import Cr from './Cr';
import Footer from './Footer';
import { Helmet } from 'react-helmet';

const Home = () => {
  setTimeout(()=>{
    document.body.classList.add('bg-white');
  },100)
  return (
   <>
   <Helmet>
        <title>Real Estate Investments | GridRadhika</title>
        <meta name="description" content="Find the best real estate investment opportunities with GridRadhika. Our properties offer great views and affordable prices." />
        <meta name="keywords" content="real estate, property investment, affordable real estate, mountain views, GridRadhika, plots, property near me, good property, flats near me, flat for rent in noida, flat for rent in gurugram, property in Uttarakhand" />
        <meta property="og:title" content="Real Estate Investments | GridRadhika" />
        <meta property="og:description" content="Looking for a smart real estate investment? GridRadhika offers premium properties at competitive prices." />
        <meta property="og:url" content="https://gridradhika.netlify.app" />
        <meta property="og:type" content="website" />
      </Helmet>
    <Navigation/>


   <div className='bgimage' >
<div className='margincontainer main'>

  <div className='left'>
    <h5 className='find'>Find Your Ideal Stay</h5>
    <h4 className='where'>  Green views, fresh air, <br /> and affordable prices</h4>

   

    <p className='plan'>Your dream home is closer than you think</p>

  </div>
  </div>
  </div>


  <div className='right'>
    </div>
    <TopD/>
    <Cr/>
    <Footer/>
   </>
  )
}

export default Home